module.exports = __webpack_public_path__ + "public/94f20a0ac34737d7f132c980e4a1a1dc5b6213c9/src/components/Footer/cruk.svg";